import SourceFlowText from "@sourceflow-uk/sourceflowtext"
import SourceFlowImage from "@sourceflow-uk/sourceflowimage"
import {
    Container,
    Col,
    Row,
    Card
} from "reactstrap";
import styles from './styles.module.scss';
import Link from "next/link"
import Address from "/public/site-assets/svg/geo-location.svg"
import Mail from "/public/site-assets/svg/mail.svg"
import Telephone from "/public/site-assets/svg/phone.svg"

import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation, Autoplay } from "swiper"

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';


export default function SpecialismDetail({
    global,
    pathPrefix,
    heading,
    specialism,
    customClass = "",
    sub_specialisms,
    enableSpecialismContent = true,
    brandLogo = false,
    profilePage = false,
    content = <div className="description p-lg-5 p-4" dangerouslySetInnerHTML={{ __html: specialism?.content }} />,
    swiperID

}) {

    const [shouldInitializeSwiper, setShouldInitializeSwiper] = useState(false);

    useEffect(() => {
        function swiperCard() {
            if (window.innerWidth <= 768 && !shouldInitializeSwiper) {
                // Initialize Swiper
                setShouldInitializeSwiper(true);
            } else if (window.innerWidth > 768 && shouldInitializeSwiper) {
                // Destroy Swiper
                setShouldInitializeSwiper(false);
            }
        }

        swiperCard();
        window.addEventListener('resize', swiperCard);

        // Clean up event listener on component unmount
        return () => {
            window.removeEventListener('resize', swiperCard);
        };
    }, [shouldInitializeSwiper]);

    return (
        <section className={`${styles.root} ${customClass} ${brandLogo ? "brand-section" : ""}`}>
            <Container>
                <div className={`rounded-3 overflow-hidden border-top ${sub_specialisms.length >= 1 ? "" : "border-bottom"}`}>
                    {enableSpecialismContent ?
                        <>
                            {content ? content : ""}
                        </> : ""}
                    {sub_specialisms.length >= 1 && (
                        <div className="content-wrapper p-lg-5 p-4">
                            <h2 className="mb-5 text-center heading">
                                <SourceFlowText global={global} path={`${pathPrefix}.heading`}>{heading}</SourceFlowText>
                            </h2>
                            <Row>
                                {shouldInitializeSwiper ?
                                    <Swiper
                                        className="card bg-transparent" // Add the class name to the Swiper container
                                        modules={[Navigation, Pagination, Autoplay]}
                                        loop={true}
                                        spaceBetween={30}
                                        slidesPerView={1}
                                        speed={500}
                                        autoplay={{
                                            delay: 5000,
                                        }}
                                        pagination={{
                                            clickable: true
                                        }}
                                    >
                                        {sub_specialisms?.map((post, index) => (
                                            <SwiperSlide key={index}>
                                                <Col md={6}>
                                                    <Card className="rounded-3 shadow overflow-hidden h-100">
                                                        <Row className="h-100">
                                                            <Col md={4}>
                                                                <SourceFlowImage
                                                                    src={post?.preview_image ? post.preview_image : "/site-assets/images/image-placeholder.webp"}
                                                                    size="800x800"
                                                                    alt={post.title}
                                                                    className="card-img rounded-0"
                                                                    width="100%"
                                                                    height="100%"
                                                                />
                                                            </Col>
                                                            <Col md={8} className="d-flex align-items-center">
                                                                <h6 className="mb-0 p-4"><strong>{post.title}</strong></h6>
                                                            </Col>
                                                        </Row>
                                                    </Card>
                                                </Col>
                                            </SwiperSlide>
                                        ))}
                                    </Swiper>
                                    :
                                    sub_specialisms?.map((post, index) => (
                                        <Col md={6} className="mb-4" key={index}>
                                            <Card className="rounded-3 shadow overflow-hidden h-100">
                                                <Row className="h-100">
                                                    <Col md={4}>
                                                        <SourceFlowImage
                                                            src={post?.preview_image ? post.preview_image : "/site-assets/images/image-placeholder.webp"}
                                                            size="800x800"
                                                            alt={post.title}
                                                            className="card-img rounded-0"
                                                            width="100%"
                                                            height="100%"
                                                        />
                                                    </Col>
                                                    <Col md={8} className="d-flex align-items-center">
                                                        <h6 className="mb-0 p-4"><strong>{post.title}</strong></h6>
                                                    </Col>
                                                </Row>
                                            </Card>
                                        </Col>
                                    ))
                                }

                                {/* {sub_specialisms?.map((post, index) => (
                                    <Col md={6} key={index} className="mb-4">
                                        <Card className="rounded-3 shadow overflow-hidden h-100">
                                            <Row className="h-100">
                                                <Col md={4}>
                                                    <SourceFlowImage
                                                        src={post?.preview_image ? post.preview_image : "/site-assets/images/image-placeholder.webp"}
                                                        size="800x800"
                                                        alt={post.title}
                                                        className="card-img rounded-0"
                                                        width="100%"
                                                        height="100%"
                                                    />
                                                </Col>
                                                <Col md={8} className="d-flex align-items-center">
                                                    <h6 className="mb-0 p-4"><strong>{post.title}</strong></h6>
                                                </Col>
                                            </Row>
                                        </Card>
                                    </Col>
                                ))} */}
                            </Row>
                        </div>
                    )}
                    {profilePage ?
                        <div className="d-flex flex-wrap p-lg-5 p-4 border border-bottom-0 contacts">
                            {specialism.telephone ?
                                <Link href={`tel:${specialism.telephone}`}><a className="me-4 position-relative ps-4 ms-1"><Telephone />{specialism.telephone}</a></Link>
                                : ""}
                            {specialism.mail ?
                                <Link href={`mailto:${specialism.email}`}><a className="me-4 position-relative ps-4 ms-1"><Mail />{specialism.email}</a></Link>
                                : ""}
                            {specialism?.address ?
                                <>
                                    <div className="position-relative ps-4 ms-1">
                                        <Address />
                                        <div className="address" dangerouslySetInnerHTML={{ __html: specialism?.address }} />
                                    </div>
                                </>
                                : ""}
                        </div>
                        : ""}
                </div>
            </Container>
        </section >

    )
}